import {Button, Col, Row} from "react-bootstrap";
import React from "react";
import {Link} from 'react-router-dom';
import AppRoute from "../../utils/AppRoute";


const AdminDashboard = () => {

    return (
        <>
            <Row>
                <Col xs={12} lg={6}>
                    <Row>
                        <Col>
                            <Row className={'mt-4 mt-lg-2'}>
                                <Col>
                                    <Button variant={'link'} onClick={() => window.history.back()}
                                            className={'link-shape p-0'}>
                                        <span>Torna al sito</span>
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={'title-page-section mt-5 header-detail mb-5'}>
                                <h2 className={'title'}>Dashboard ADMIN</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={8} lg={12} xl={8}>
                            <Link to={AppRoute.ADMIN_ORDERS} className="card card-course">
                                <div className="card-body">
                                    <div className={'d-flex w-100 justify-content-between'}>
                                        <h5 className="card-title">Ordini</h5>
                                        <svg viewBox="0 0 72.7 59.6" className="btn btn-card mt-4">
                                            <g>
                                                <path className="st0" d="M35.6,52.3l16-15.4c-3.4,1.3-6.9,1.9-10.6,1.9c-3.1,0-5.9-0.4-8.4-1.1c-2.5-0.7-5.3-1.8-8.4-3.1
                                            c-2.7-1.1-4.7-1.9-6.2-2.4c-1.5-0.5-3-0.7-4.7-0.7C8.5,31.5,4.1,33.3,0,37V25.7c3.7-3.3,8.1-4.9,13.3-4.9c2.2,0,4.2,0.3,6,0.8
                                            c1.8,0.5,4.1,1.4,7,2.6c2.8,1.3,5.3,2.2,7.4,2.9c2.2,0.6,4.6,1,7.2,1c4.5,0,8.8-1.1,12.7-3.4L35.6,7.2L42.8,0l29.9,29.8L42.8,59.6
                                            L35.6,52.3z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={8} lg={12} xl={8}>
                            <Link to={AppRoute.ADMIN_COURSES} className="card card-course">
                                <div className="card-body">
                                    <div className={'d-flex w-100 justify-content-between'}>
                                        <h5 className="card-title">Corsi</h5>
                                        <svg viewBox="0 0 72.7 59.6" className="btn btn-card mt-4">
                                            <g>
                                                <path className="st0" d="M35.6,52.3l16-15.4c-3.4,1.3-6.9,1.9-10.6,1.9c-3.1,0-5.9-0.4-8.4-1.1c-2.5-0.7-5.3-1.8-8.4-3.1
                                            c-2.7-1.1-4.7-1.9-6.2-2.4c-1.5-0.5-3-0.7-4.7-0.7C8.5,31.5,4.1,33.3,0,37V25.7c3.7-3.3,8.1-4.9,13.3-4.9c2.2,0,4.2,0.3,6,0.8
                                            c1.8,0.5,4.1,1.4,7,2.6c2.8,1.3,5.3,2.2,7.4,2.9c2.2,0.6,4.6,1,7.2,1c4.5,0,8.8-1.1,12.7-3.4L35.6,7.2L42.8,0l29.9,29.8L42.8,59.6
                                            L35.6,52.3z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={8} lg={12} xl={8}>
                            <Link to={AppRoute.ADMIN_LEVELS} className="card card-course">
                                <div className="card-body">
                                    <div className={'d-flex w-100 justify-content-between'}>
                                        <h5 className="card-title">Livelli</h5>
                                        <svg viewBox="0 0 72.7 59.6" className="btn btn-card mt-4">
                                            <g>
                                                <path className="st0" d="M35.6,52.3l16-15.4c-3.4,1.3-6.9,1.9-10.6,1.9c-3.1,0-5.9-0.4-8.4-1.1c-2.5-0.7-5.3-1.8-8.4-3.1
                                            c-2.7-1.1-4.7-1.9-6.2-2.4c-1.5-0.5-3-0.7-4.7-0.7C8.5,31.5,4.1,33.3,0,37V25.7c3.7-3.3,8.1-4.9,13.3-4.9c2.2,0,4.2,0.3,6,0.8
                                            c1.8,0.5,4.1,1.4,7,2.6c2.8,1.3,5.3,2.2,7.4,2.9c2.2,0.6,4.6,1,7.2,1c4.5,0,8.8-1.1,12.7-3.4L35.6,7.2L42.8,0l29.9,29.8L42.8,59.6
                                            L35.6,52.3z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={8} lg={12} xl={8}>
                            <Link to={AppRoute.ADMIN_POOLS} className="card card-course">
                                <div className="card-body">
                                    <div className={'d-flex w-100 justify-content-between'}>
                                        <h5 className="card-title">Piscine</h5>
                                        <svg viewBox="0 0 72.7 59.6" className="btn btn-card mt-4">
                                            <g>
                                                <path className="st0" d="M35.6,52.3l16-15.4c-3.4,1.3-6.9,1.9-10.6,1.9c-3.1,0-5.9-0.4-8.4-1.1c-2.5-0.7-5.3-1.8-8.4-3.1
                                            c-2.7-1.1-4.7-1.9-6.2-2.4c-1.5-0.5-3-0.7-4.7-0.7C8.5,31.5,4.1,33.3,0,37V25.7c3.7-3.3,8.1-4.9,13.3-4.9c2.2,0,4.2,0.3,6,0.8
                                            c1.8,0.5,4.1,1.4,7,2.6c2.8,1.3,5.3,2.2,7.4,2.9c2.2,0.6,4.6,1,7.2,1c4.5,0,8.8-1.1,12.7-3.4L35.6,7.2L42.8,0l29.9,29.8L42.8,59.6
                                            L35.6,52.3z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={8} lg={12} xl={8}>
                            <Link to={AppRoute.ADMIN_COUPONS} className="card card-course">
                                <div className="card-body">
                                    <div className={'d-flex w-100 justify-content-between'}>
                                        <h5 className="card-title">Coupon</h5>
                                        <svg viewBox="0 0 72.7 59.6" className="btn btn-card mt-4">
                                            <g>
                                                <path className="st0" d="M35.6,52.3l16-15.4c-3.4,1.3-6.9,1.9-10.6,1.9c-3.1,0-5.9-0.4-8.4-1.1c-2.5-0.7-5.3-1.8-8.4-3.1
                                            c-2.7-1.1-4.7-1.9-6.2-2.4c-1.5-0.5-3-0.7-4.7-0.7C8.5,31.5,4.1,33.3,0,37V25.7c3.7-3.3,8.1-4.9,13.3-4.9c2.2,0,4.2,0.3,6,0.8
                                            c1.8,0.5,4.1,1.4,7,2.6c2.8,1.3,5.3,2.2,7.4,2.9c2.2,0.6,4.6,1,7.2,1c4.5,0,8.8-1.1,12.7-3.4L35.6,7.2L42.8,0l29.9,29.8L42.8,59.6
                                            L35.6,52.3z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={8} lg={12} xl={8}>
                            <Link to={AppRoute.ADMIN_REPORT} className="card card-course">
                                <div className="card-body">
                                    <div className={'d-flex w-100 justify-content-between'}>
                                        <h5 className="card-title">Report</h5>
                                        <svg viewBox="0 0 72.7 59.6" className="btn btn-card mt-4">
                                            <g>
                                                <path className="st0" d="M35.6,52.3l16-15.4c-3.4,1.3-6.9,1.9-10.6,1.9c-3.1,0-5.9-0.4-8.4-1.1c-2.5-0.7-5.3-1.8-8.4-3.1
                                            c-2.7-1.1-4.7-1.9-6.2-2.4c-1.5-0.5-3-0.7-4.7-0.7C8.5,31.5,4.1,33.3,0,37V25.7c3.7-3.3,8.1-4.9,13.3-4.9c2.2,0,4.2,0.3,6,0.8
                                            c1.8,0.5,4.1,1.4,7,2.6c2.8,1.3,5.3,2.2,7.4,2.9c2.2,0.6,4.6,1,7.2,1c4.5,0,8.8-1.1,12.7-3.4L35.6,7.2L42.8,0l29.9,29.8L42.8,59.6
                                            L35.6,52.3z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>

    );
}

export default AdminDashboard;
